export const SEARCH_DEFAULT_LOCATION = 'search/def-location';
export const SEARCH_LOCATION = 'search/location';
export const SEARCH_PLACE_LOCATION = 'searchPlace/location';
